export const delay = (t: number) => new Promise((r) => setTimeout(r, t));
